<template>
	<CardListBuilder :use-new-version="true" :items="items" :fields="fields" :hide-status="false" :toggle-mode="true"> </CardListBuilder>
</template>

<script>
import { rendCurrency } from '~helpers';
import languageMessages from '@/mixins/languageMessages';

export default {
	name: 'MobileViewsValidatePoDetailsListComponent',
	mixins: [languageMessages],
	props: {
		items: {
			type: Array,
			required: true,
			default: () => []
		},
		fields: {
			type: Array,
			required: true,
			default: () => []
		}
	},
	methods: {
		handleCardClick() {
			this.$emit('card-clicked', this.item);
		},

		/**
		 * @param {Number} price
		 * @return {String}
		 */
		rendPrice(price) {
			return rendCurrency(price);
		},
		/**
		 * @param {Number} total
		 * @return {String}
		 */
		rendTotal(total) {
			return rendCurrency(total);
		}
	}
};
</script>

<style lang="scss" scoped>
.head,
.content {
	width: 100%;
}
.head {
	padding-bottom: 10px;
}
.content {
	display: flex;
	justify-content: space-between;
}
</style>
